import styled from 'styled-components';

export const SearchButton = styled.div`
  border: 1px solid #e2e8f0;
  width: 100%;
  border-radius: 14px;
  background-color: #f8fafc80;
  margin: 20px 0;
  height: 75px;
  padding: 15px;

  > div {
    width: max-content;

    .action-button {
      max-height: 38px;
      max-width: 120px;
      font-size: 12px;
      color: #212529;
      font-style: normal;
      line-height: normal;

      img {
        color: white;
      }
    }
  }
`;

export const InputWrapper = styled.div`
  border: 1px solid #e2e8f0;
  width: 100%;
  border-radius: 14px;
  background-color: #ffffff;
  display: flex;
  gap: 15px;
  padding: 15px;
  align-items: center;

  > div {
    min-height: 0;
  }

  .input {
    color: #6c757d;
  }
  .label {
    color: #6c757d !important;
  }
`;

export const TableContainer = styled.div`
  margin-top: 15px;
  margin-left: 15px;
  border-radius: 14px;
`;

export const ClearAllRow = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const ClearAllColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;

export const ClearAllText = styled.span`
  color: #212529;
  font-size: 10px;
  font-weight: 700;
  text-decoration: underline;
  margin-top: 40px;
`;

export const Icon = styled.img`
  width: 15px;
  height: 15px;
`;

export const ConfigureButton = styled.button`
  padding: 6px 12px;
  border-radius: 20px;
  border: 1px solid #ccc;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 6px;
  width: 113px;
  height: 32px;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 10px;
  border-radius: 20px;
  border: ${({ isActive }) => (isActive ? '1px solid #15C7A7' : 'none')};
  background: ${({ isActive }) => (isActive ? '#FFFFFF' : '#F8FAFC')};
  width: fit-content;

  p {
    color: ${({ isActive }) => (isActive ? '#15C7A7' : '#62748E')};
    margin: 0;
  }
`;

export const TableWrapper = styled.div`
  margin-top: 20px;
`;
